import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "../../../theme";
import { SCROLLABLE_ERROR_ID } from "../../../scroll-to-error";
import { getFormFieldComponent, getFormFieldError, isInvalid, } from "../../formHelpers";
import { useBlockComponentContext } from "../../..";
export const FieldError = ({ name }) => {
    const FormField = getFormFieldComponent(name);
    const { Markdown } = useBlockComponentContext();
    return (_jsx(FormField, { name: name, children: ({ form }) => isInvalid(name, form) ? (_jsx(FieldErrorText, { id: `${SCROLLABLE_ERROR_ID}-${name}`, "data-test-id": `field-error-${name}`, children: _jsx(Markdown, { source: getFormFieldError(name, form), values: form.values }) })) : null }));
};
export const FieldErrorText = styled.div `
  color: ${({ theme }) => theme.color.deepOrange100};
  font-size: 1.25em;
  padding: 10px 5px;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  text-align: left;
`;
